import Vue from 'vue'
import AppHandler from '@jamescoyle/paper-vue/app-handler'

import app from './app.vue'
import router from './router'
import store from './store'

import './registerServiceWorker'

Vue.config.productionTip = false
Vue.use(AppHandler)

new Vue({
	router,
	store,
	render: (h) => h(app),
}).$mount('#app')
